<div class="flex" [ngClass]="{ 'flex-column gap-0': vertical, 'gap-2' : !vertical }">
  <div class="text-base font-light text-700">{{label}}</div>
  <div *ngIf="!withIcon" class="text-base">{{ value ? trueText : falseText }}</div>
  <div *ngIf="withIcon" class="text-base">
    <mat-icon [class]="'material-symbols-outlined boolean-icon-size ' + (value ? trueColor : falseColor)">{{ value ? trueIcon : falseIcon }}</mat-icon>
  </div>
</div>
